import styles from "./index.module.css"

const CircleLoader = () => {
  return <div className={styles.Loader}></div>
}

export default CircleLoader
